import { getDistance } from 'geolib'

const distance = (Lat1, Long1, Lat2, Long2) => {
  return Math.floor(
    getDistance(
      {
        latitude: Lat1,
        longitude: Long1,
      },
      { latitude: Lat2, longitude: Long2 }
    ) / 1000
  )
}
export default distance
